export default function initMenuCardsClickable() {
    const menuCardLinks = document.querySelectorAll('.block-product .tw-block-title > a');

    menuCardLinks.forEach((menuCardLink) => {
        menuCardLink.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });
}
